/* Manoflex City / Gravel / Extreme: grip diameter and combined Shopify options. */
(() => {
  if (window.__manoflexGripFitReady) return;
  window.__manoflexGripFitReady = true;

  const diameters = Object.freeze({ XS:'30', S:'32', M:'32', L:'34', XL:'35.5', XXL:'35.5' });

  const refresh = (picker) => {
    if (!picker) return;
    const size = picker.querySelector('[data-manoflex-glove-option] input[type="radio"]:checked')?.value;
    const output = picker.querySelector('[data-manoflex-diameter]');
    if (size && output && Object.hasOwn(diameters,size)) output.textContent = diameters[size] + ' mm';

    const combined = picker.querySelector('[data-manoflex-combined-option] select');
    if (combined) {
      const parts = combined.value.split(' - ');
      if (parts.length === 2) {
        for (const input of picker.querySelectorAll('[data-manoflex-custom-length]')) {
          input.checked = input.value === parts[0];
        }
        for (const input of picker.querySelectorAll('[data-manoflex-custom-mount]')) {
          input.checked = input.value === parts[1];
        }
      }
    }
  };

  /* Capture synthetic controls before Dawn processes an incomplete option selection. */
  document.addEventListener('change', (event) => {
    const target = event.target;
    const picker = target.closest?.('variant-selects[data-manoflex-bicycle]');
    if (!picker) return;
    if (target.matches('[data-manoflex-custom-length], [data-manoflex-custom-mount]')) {
      event.stopPropagation();
      const length = picker.querySelector('[data-manoflex-custom-length]:checked')?.value;
      const mount = picker.querySelector('[data-manoflex-custom-mount]:checked')?.value;
      const combined = picker.querySelector('[data-manoflex-combined-option] select');
      const value = length && mount ? length + ' - ' + mount : '';
      if (combined && value && combined.value !== value) {
        combined.value = value;
        combined.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    refresh(picker);
  }, true);

  const refreshAll = () => document.querySelectorAll('variant-selects[data-manoflex-bicycle]').forEach(refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll, { once:true });
  } else {
    refreshAll();
  }
  document.addEventListener('shopify:section:load', refreshAll);
})();
